module.exports = __webpack_public_path__ + "static/img/ggsm.6ce95ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggsm.jpg
// module id = 6iR6
// module chunks = 1